/* unplugin-vue-components disabled */import { render } from "./xingyun.vue?vue&type=template&id=e69efa50&scoped=true"
import script from "./xingyun.vue?vue&type=script&lang=js"
export * from "./xingyun.vue?vue&type=script&lang=js"

import "./xingyun.vue?vue&type=style&index=0&id=e69efa50&lang=scss&scoped=true"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e69efa50"]])

export default __exports__